import { convertFromHTML } from "draft-convert";
import { ContentState, convertFromRaw, convertToRaw } from "draft-js";

export function contentStateFromString(content: string): ContentState {
	try {
		return content ? convertFromRaw(JSON.parse(content)) : ContentState.createFromText("");
	} catch {
		return convertFromHTML({})(content);
	}
}

export function contentStateToString(contentState: ContentState): string {
	return JSON.stringify(convertToRaw(contentState));
}
